import { render, staticRenderFns } from "./GatButtonMenu.vue?vue&type=template&id=5eacfec6&scoped=true&"
import script from "./GatButtonMenu.vue?vue&type=script&lang=js&"
export * from "./GatButtonMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eacfec6",
  null
  
)

export default component.exports